import { jwtDecode } from "jwt-decode";
import { Service } from "typedi";
import { IStJwtObj } from "../../../application/core/models/IStJwtObj";
import { InternalsMonitor } from "../../../application/core/services/monitoring/InternalsMonitor";
import { ConfigProvider } from "../config-provider/ConfigProvider";
import {
  JwtValidationError,
  JWT_PAYLOAD_MISSING_ERROR,
} from "./JwtValidationError";

@Service()
export class JwtDecoder {
  constructor(protected configProvider: ConfigProvider) {}

  decode<T>(jwt: string): IStJwtObj<T> {
    if (!jwt) {
      //The JWT could not be decoded: {error.message}
      const error = new Error("Invalid 'JWT', undefined or empty string.");
      // Using static, because JwtDecoder is loaded before the container registration
      InternalsMonitor.getInstance().recordIssue(
        error,
        this.configProvider.getConfig(),
      );
      throw error;
    }

    try {
      const decodedJwt = jwtDecode<IStJwtObj<T>>(jwt);

      // Validate that the payload key exists
      if (!("payload" in decodedJwt)) {
        const error = new JwtValidationError(JWT_PAYLOAD_MISSING_ERROR);
        throw error;
      }

      return decodedJwt;
    } catch (error: unknown) {
      // Re-throw our validation errors without recording
      if (error instanceof JwtValidationError) {
        throw error;
      }

      // Using static, because JwtDecoder is loaded before the container registration
      InternalsMonitor.getInstance().recordIssue(
        //@ts-ignore
        //ignored Ignored, as the exact error type cannot be determined at this stage.
        new Error(`The 'JWT' could not be decoded: ${error.message}`),
        this.configProvider.getConfig(),
      );
      //eslint-disable-next-line preserve-caught-error
      throw new Error(`Invalid 'JWT', cannot parse: ${jwt}.`);
    }
  }
}
